// extracted by mini-css-extract-plugin
module.exports = {"deliver":"styles_deliver__FF88x","pulse":"styles_pulse__11dMA","jump":"styles_jump__d4BZu","wiggle":"styles_wiggle__U_len"};